import IAction from "../store/IAction"
import InitState from "../store/initState"
import ICreateApplicationForExemptedCitizenVm from "../models/issuingAuthority/ICreateApplicationForExemptedCitizenVm"
import * as ICreateApplicationForExemptedCitizenVmInstance from "../models/issuingAuthority/ICreateApplicationForExemptedCitizenVm"
import { CertificateProcessType } from "../models/flags/CertificateProcessType"
import { FormerLicenseType } from "../models/enums/FormerLicenseType"
import IMunicipalityVm from "../models/shared/IMunicipalityVm"
import { CertificateType } from "../models/flags/CertificateType"
import IApplicationVm from "../models/shared/IApplicationVm"
import * as IAddressVmInstance from "../models/shared/IAddressVm"
import addressReducer from "./addressReducer"
import { ActorSubmittingApplicationType } from "../models/enums/ActorSubmittingApplicationType"
import IEducationalInstitutionVm from "../models/shared/IEducationalInstitutionVm"

const REPLACE_APPLICATION_FOR_EXEMPTED = "BAT2/applicationForExempted/REPLACE_APPLICATION_FOR_EXEMPTED"
const UPDATE_APPLICATION_CITIZEN_SUBMIT_TYPE = "BAT2/applicationForExempted/UPDATE_APPLICATION_CITIZEN_SUBMIT_TYPE"
const UPDATE_CERTIFICATE_PROCESS_TYPE = "BAT2/applicationForExempted/UPDATE_CERTIFICATE_PROCESS_TYPE"
const UPDATE_CERTIFICATE_TYPE = "BAT2/applicationForExempted/UPDATE_CERTIFICATE_TYPE"
const UPDATE_CIVIL_REGISTRATION_IDENTIFIER = "BAT2/applicationForExempted/UPDATE_CIVIL_REGISTRATION_IDENTIFIER"
const UPDATE_DRIVERS_LICENSE_NUMBER = "BAT2/applicationForExempted/UPDATE_DRIVERS_LICENSE_NUMBER"
const UPDATE_FORMER_ISSUING_MUNICIPALITY = "BAT2/applicationForExempted/UPDATE_FORMER_ISSUING_MUNICIPALITY"
const UPDATE_FORMER_LICENSE_EXPIRE_DATE = "BAT2/applicationForExempted/UPDATE_FORMER_LICENSE_EXPIRE_DATE"
const UPDATE_FORMER_LICENSE_NUMBER = "BAT2/applicationForExempted/UPDATE_FORMER_LICENSE_NUMBER"
const UPDATE_FORMER_LICENSE_TYPE = "BAT2/applicationForExempted/UPDATE_FORMER_LICENSE_TYPE"
const UPDATE_LIST_OF_EXISTING_APPLICATIONS = "BAT2/applicationForExempted/UPDATE_LIST_OF_EXISTING_APPLICATIONS"
const UPDATE_PHONENUMBER = "BAT2/applicationForExempted/UPDATE_PHONENUMBER"
const UPDATE_USE_SECONDARY_DELIVERY_ADDRESS = "BAT2/applicationForExempted/UPDATE_USE_SECONDARY_DELIVERY_ADDRESS"
const UPDATE_EDUCATIONAL_INSTITUTION = "BAT2/applicationForExempted/UPDATE_EDUCATIONAL_INSTITUTION"

export default function applicationForExemptedReducer(state: ICreateApplicationForExemptedCitizenVm = new InitState().applicationForExempted, action: IAction): ICreateApplicationForExemptedCitizenVm {
    switch (action.type) {
        case UPDATE_CIVIL_REGISTRATION_IDENTIFIER:
            return { ...state, civilRegistrationIdentifier: action.payload }
        case UPDATE_CERTIFICATE_TYPE:
            return { ...state, certificateType: action.payload }
        case UPDATE_CERTIFICATE_PROCESS_TYPE:
            return { ...state, certificateProcessType: action.payload }
        case UPDATE_FORMER_LICENSE_TYPE:
            return { ...state, formerLicenseType: action.payload }
        case UPDATE_FORMER_ISSUING_MUNICIPALITY:
            return { ...state, formerIssuingMunicipality: action.payload }
        case UPDATE_FORMER_LICENSE_NUMBER:
            return { ...state, formerTaxLicenseNumber: action.payload }
        case UPDATE_FORMER_LICENSE_EXPIRE_DATE:
            return { ...state, formerTaxLicenseExpireDate: action.payload }
        case UPDATE_DRIVERS_LICENSE_NUMBER:
            return { ...state, driverlicenseNumber: action.payload }
        case UPDATE_LIST_OF_EXISTING_APPLICATIONS:
            return { ...state, existingApplications: action.payload }
        case UPDATE_USE_SECONDARY_DELIVERY_ADDRESS:
            if (!state.secondaryDeliveryAddress.countryName) {
                return {
                    ...state,
                    useSecondaryDeliveryAddress: action.payload,
                    secondaryDeliveryAddress: {
                        ...state.secondaryDeliveryAddress,
                        countryName: "Danmark",
                        countryCode: "DK"
                    }
                }
            } else {
                return { ...state, useSecondaryDeliveryAddress: action.payload }
            }
        case UPDATE_PHONENUMBER:
            return { ...state, phonenumber: action.payload }
        case UPDATE_APPLICATION_CITIZEN_SUBMIT_TYPE:
            return { ...state, actorSubmittingApplicationType: action.payload }
        case UPDATE_EDUCATIONAL_INSTITUTION:
            return { ...state, educationalInstitution: action.payload }
        case REPLACE_APPLICATION_FOR_EXEMPTED:
            return { ...action.payload }
        default:
            return {
                ...state, secondaryDeliveryAddress: addressReducer(state.secondaryDeliveryAddress, action)
            }
    }
}

export function updateCivilRegistrationIdentifier(civilRegistrationIdentifier: string) {
    return { type: UPDATE_CIVIL_REGISTRATION_IDENTIFIER, payload: civilRegistrationIdentifier.replace("-", "") }
}
export function updateCertificateType(certificateType: CertificateType) {
    return { type: UPDATE_CERTIFICATE_TYPE, payload: certificateType }
}
export function updateCertificateProcessType(certificateProcessType: CertificateProcessType) {
    return { type: UPDATE_CERTIFICATE_PROCESS_TYPE, payload: certificateProcessType }
}
export function updateFormerLicenseType(formerLicenseType: FormerLicenseType) {
    return { type: UPDATE_FORMER_LICENSE_TYPE, payload: formerLicenseType }
}
export function updateFormerIssuingMunicipality(formerIssuingMunicipality: IMunicipalityVm) {
    return { type: UPDATE_FORMER_ISSUING_MUNICIPALITY, payload: formerIssuingMunicipality }
}
export function updateFormerLicenseNumber(formerLicenseNumber: string) {
    return { type: UPDATE_FORMER_LICENSE_NUMBER, payload: formerLicenseNumber }
}
export function updateFormerLicenseExpireDate(formerLicenseExpireDate: string) {
    return { type: UPDATE_FORMER_LICENSE_EXPIRE_DATE, payload: formerLicenseExpireDate }
}
export function updateDriversLicenseNumber(driversLicenseNumber: string) {
    return { type: UPDATE_DRIVERS_LICENSE_NUMBER, payload: driversLicenseNumber }
}
export function addListOfExistingApplications(listOfExistingApplications: IApplicationVm[]) {
    return { type: UPDATE_LIST_OF_EXISTING_APPLICATIONS, payload: listOfExistingApplications }
}
export function updateUseSecondaryDeliveryAddress(useSecondaryDeliveryAddress: boolean) {
    return { type: UPDATE_USE_SECONDARY_DELIVERY_ADDRESS, payload: useSecondaryDeliveryAddress }
}
export function updatePhonenumber(phonenumber: string) {
    return { type: UPDATE_PHONENUMBER, payload: phonenumber }
}
export function updateActorSubmittingApplicationType(actorSubmittingApplicationType: ActorSubmittingApplicationType) {
    return { type: UPDATE_APPLICATION_CITIZEN_SUBMIT_TYPE, payload: actorSubmittingApplicationType }
}
export function updateEducationalInstitution(educationalInstitution: IEducationalInstitutionVm) {
    return { type: UPDATE_EDUCATIONAL_INSTITUTION, payload: educationalInstitution }
}
export function replaceApplicationForExempted() {
    // Create an empty applicationForExempted, but set applicationId and secondaryDeliveryAddress_id, to make sure
    // that redux updates the correct object.
    const applicationForExempted = {
        ...ICreateApplicationForExemptedCitizenVmInstance.empty(),
        applicationId: Math.random().toString(),
        secondaryDeliveryAddress: {
            ...IAddressVmInstance.empty(),
            id: Math.random().toString()
        }
    }

    return { type: REPLACE_APPLICATION_FOR_EXEMPTED, payload: applicationForExempted }
}
